export default function Contact() {
  return (
    <section id="contact" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="bg-background-100 rounded-3xl p-8 md:p-12 relative overflow-hidden">
          <div className="absolute top-0 right-0 w-72 h-72 bg-primary-100/40 rounded-full -translate-y-1/2 translate-x-1/4 blur-3xl"></div>
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-accent-100/30 rounded-full translate-y-1/2 -translate-x-1/4 blur-3xl"></div>

          <div className="relative z-10 flex flex-col lg:flex-row items-center gap-8 lg:gap-14">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
                联系我们
              </h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-[480px] mx-auto lg:mx-0">
                无论是影片推荐、问题反馈还是合作洽谈，六六影院团队随时欢迎你的声音。
                你的每一次反馈，都是我们不断优化观影体验的动力。
              </p>
              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 mt-5">
                <div className="flex items-center gap-2 text-sm text-foreground-700">
                  <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                    <i className="ri-mail-line"></i>
                  </div>
                  <span>contact@66cinema.com</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-foreground-700">
                  <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600">
                    <i className="ri-wechat-line"></i>
                  </div>
                  <span>六六影院官方</span>
                </div>
              </div>
            </div>

            <div className="flex-shrink-0">
              <a
                href="mailto:contact@66cinema.com"
                className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-foreground-950 font-semibold text-sm md:text-base hover:bg-primary-400 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-send-plane-line text-lg"></i>
                发送反馈
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}